"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withFlag = _interopRequireDefault(require("./withFlag"));

var _Case = _interopRequireDefault(require("./Case"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const isFlagrCase = variant => element => element && (!element.props.variant || element.props.variant === variant);

const assertFlagrCaseElement = element => {
  if (element && element.type !== _Case.default) throw new Error('Only instances of FlagrCase are allowed as direct children of FlagrSwitch.');
};

class FlagrSwitch extends _react.PureComponent {
  renderVariant(flag) {
    const children = _react.default.Children.toArray(this.props.children);

    children.forEach(assertFlagrCaseElement);
    const element = children.filter(isFlagrCase(flag.variantKey)).shift();
    if (element) return /*#__PURE__*/_react.default.cloneElement(element, {
      value: flag
    });else return null;
  }

  render() {
    const {
      LoadingComponent,
      flag
    } = this.props;
    if (flag) return this.renderVariant(flag);else if (LoadingComponent) return /*#__PURE__*/_react.default.createElement(LoadingComponent, null);else return null;
  }

}

_defineProperty(FlagrSwitch, "propTypes", {
  flagKey: _propTypes.default.string.isRequired
});

var _default = (0, _withFlag.default)(props => props.flagKey)(FlagrSwitch);

exports.default = _default;